/* Chemiseed global form honeypot (June 2026 optimisation sprint).
   Injects a hidden trap field into Shopify customer (newsletter) and contact
   forms and blocks submission if a bot fills it. Protects Mailchimp contact
   count and reduces contact-form spam. The PDP quote form already ships its own
   honeypot (name="website"); this guard covers that field too. */
(function () {
  function isTarget(form) {
    var a = (form.getAttribute('action') || '');
    return (
      a.indexOf('/contact') !== -1 ||
      form.id === 'contactForm' ||
      !!form.querySelector('input[name="contact[email]"]')
    );
  }

  var hpCount = 0;

  function addHoneypot(form) {
    if (form.getAttribute('data-hp-ready')) return;
    if (!isTarget(form)) return;
    /* Skip if a honeypot already exists on this form */
    if (form.querySelector('input[name="website"], input[name="contact[hp_url]"]')) {
      form.setAttribute('data-hp-ready', '1');
      return;
    }
    var wrap = document.createElement('div');
    wrap.setAttribute('aria-hidden', 'true');
    wrap.style.cssText =
      'position:absolute!important;left:-9999px!important;top:auto!important;width:1px;height:1px;overflow:hidden;';
    /* 24 Sept 2026: one id per form. A page with the lead form and the footer newsletter form
       otherwise carried two elements with the id cs-hp-url, and both labels pointed at the first. */
    hpCount += 1;
    var hpId = hpCount === 1 ? 'cs-hp-url' : 'cs-hp-url-' + hpCount;
    var label = document.createElement('label');
    label.setAttribute('for', hpId);
    label.textContent = 'Leave this field empty';
    var input = document.createElement('input');
    input.type = 'text';
    input.id = hpId;
    input.name = 'contact[hp_url]';
    input.tabIndex = -1;
    input.setAttribute('autocomplete', 'off');
    input.value = '';
    wrap.appendChild(label);
    wrap.appendChild(input);
    form.appendChild(wrap);
    form.setAttribute('data-hp-ready', '1');
  }

  function scan() {
    var forms = document.querySelectorAll('form');
    for (var i = 0; i < forms.length; i++) addHoneypot(forms[i]);
  }

  /* Capture-phase guard: block submit if the trap is filled (beats other handlers) */
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      var hp = form.querySelector('input[name="contact[hp_url]"], input[name="website"]');
      if (hp && hp.value && hp.value.trim() !== '') {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (window.console) console.warn('Honeypot triggered; form submission blocked.');
        return false;
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  /* Re-scan for dynamically injected forms (e.g. modal/newsletter popups) */
  if (window.MutationObserver) {
    var mo = new MutationObserver(function () { scan(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/* ============================================================
   Chemiseed Google Ads lead-tracking + time-trap. Appended 2026-07-18.
   Gates lead events behind honeypot + a 3s time-trap, and fires
   generate_lead for the two sources the theme's global handler misses:
     - WhatsApp modal (id="contactForm"), which opens via window.open
     - Contact-Us "Request a quote" (id="cs-form"), which posts to Mailchimp
   It does NOT re-fire the consultation form (the global handler already
   fires generate_lead for action*="/contact"), so there is no double count.
   Timestamps are stored on the form dataset, so nothing is added to any POST.
   ============================================================ */
(function () {
  "use strict";
  var MIN_MS = 3000;
  var HP = ['contact[hp_url]', 'website', 'website_url'];
  var fired = {};
  function hpFilled(f) {
    for (var i = 0; i < HP.length; i++) {
      var el = f.querySelector('[name="' + HP[i] + '"]');
      if (el && String(el.value || '').trim() !== '') return true;
    }
    return false;
  }
  function stamp(f) { if (f && f.dataset && !f.dataset.csRenderTs) f.dataset.csRenderTs = String(Date.now()); }
  function human(f) {
    if (hpFilled(f)) return false;
    var t = Number((f.dataset && f.dataset.csRenderTs) || 0);
    if (t && (Date.now() - t) < MIN_MS) return false;
    return true;
  }
  function fire(source, meta) {
    if (fired[source]) return; fired[source] = true;
    var p = Object.assign({ event: 'generate_lead', lead_source: source, currency: 'MYR', value: 1 }, meta || {});
    (window.dataLayer = window.dataLayer || []).push(p);
    if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', p);
  }
  window.csLeadGuard = { human: human, fire: fire, stamp: stamp };
  function stampAll() {
    ['#consultationForm', '#cs-form', '#contactForm', 'form[action*="/contact"]'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(stamp);
    });
  }
  /* 10 Oct 2026 (H-10): the WhatsApp modal lead fires only when the visitor picks a WhatsApp option, i.e. the
     click on an options-panel button that opens WhatsApp (openWhatsAppWeb, openWhatsAppApp or
     openWhatsAppMobile in snippets/whatsapp-contact.liquid). Opening the options panel, the
     "Copy number and message" button and an invalid submit (the panel never opens) send nothing.
     The listener runs in the capture phase, before the button's own handler resets the form, so the
     routed company is still readable. wa_option (web, app, mobile) matches the whatsapp_click event that
     Tag Manager sends for the same click (tag "WhatsApp modal - option listener"). */
  function hookModal() {
    if (document.__csWaOption) return; document.__csWaOption = 1;
    document.addEventListener('click', function (e) {
      var t = e.target, b = t && t.closest ? t.closest('.options-modal button.option-btn') : null;
      if (!b) return;
      var m = (b.getAttribute('onclick') || '').match(/openWhatsApp(Web|App|Mobile)\s*\(\s*'([^']*)'/);
      if (!m) return;
      var f = document.getElementById('contactForm');
      if (fired.whatsapp_modal || !f || !human(f)) return;
      /* 17 Oct 2026: one WhatsApp lead per session, shared with the inline wa.me link tracker in layout/theme.liquid
         (sessionStorage key cs_gl_whatsapp): a direct wa.me click and a pop-up option pick in the same session count once. */
      var waSeen = false;
      try { waSeen = !!window.sessionStorage.getItem('cs_gl_whatsapp'); } catch (err) { waSeen = false; }
      if (waSeen) { fired.whatsapp_modal = true; return; }
      try { window.sessionStorage.setItem('cs_gl_whatsapp', '1'); } catch (err) {}
      var c = (f.querySelector('#company') || {}).value || m[2] || '';
      fire('whatsapp_modal', { contact_method: 'whatsapp', wa_option: m[1].toLowerCase(), routed_company: c, conversion_tier: 'secondary' });
    }, true);
  }
  function hookContactUs() {
    var f = document.getElementById('cs-form');
    if (!f || f.__csLead) return; f.__csLead = 1;
    f.addEventListener('submit', function () {
      if (!human(f)) return;
      fire('contact_us_quote', { contact_method: 'form', conversion_tier: 'primary' });
    }, false);
  }
  function init() { stampAll(); hookModal(); hookContactUs(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  if (window.MutationObserver) {
    new MutationObserver(function () { stampAll(); hookContactUs(); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }
})();
